/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import $ from '@/jquery'
import _ from '@/underscore'
import ox from '@/ox'
import moment from '@/moment'
import http from '@/io.ox/core/http'
import capabilities from '@/io.ox/core/capabilities'
import theming from '@/io.ox/core/theming/main'
import ext from '@/io.ox/core/extensions'

/**
 * LIVE DEBUGGING
 *
 * Enable via URL hash parameter.
 * Example: `&debug=core,boot`
 *
 * Possible values
 * - core
 * - boot
 * - session
 * - actions
 * - autocomplete
 */

// enable special logging to investigate why boot fails
let debug = $.noop

if (/\bcore/.test(_.url.hash('debug'))) {
  debug = function () {
    const args = _(arguments).toArray(); const t = _.now() - ox.t0
    args.unshift('core (' + (t / 1000).toFixed(1) + 's): ')
    console.log.apply(console, args)
  }
}

// utility belt for dev & debugging
if (ox.debug || _.url.hash('debug')) {
  _.extend(window, { $, _, ox, capabilities, moment, http, theming, ext })
}

if (_.url.hash('debug-mw') === 'true') {
  console.warn('[middleware/debug] Enabled parameter `includeStackTraceOnError` for all requests')
  ox.on('http:before:send', ({ params }) => { params.includeStackTraceOnError = true })
}

export default debug
